module.exports = __webpack_public_path__ + "img/anhnen1.713b7957.jpg";